import * as types from './mutation_types'

export default {
  [types.RESET] (state) {
    Object.assign(state, {
      error: '',
      isLoading: false,
      items: [],
      view: {},
      violations: null,
      categories: [],
      isLoadingCategories: false,
      territories: [],
      isLoadingTerritories: false,
      games: [],
      isLoadingGames: false
    })
  },

  [types.SET_ERROR] (state, error) {
    Object.assign(state, { error })
  },

  [types.SET_ITEMS] (state, items) {
    Object.assign(state, { items })
  },

  [types.TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  },

  [types.SET_VIEW] (state, view) {
    Object.assign(state, { view })
  },

  [types.SET_VIOLATIONS] (state, violations) {
    Object.assign(state, { violations })
  },

  [types.SET_CATEGORIES] (state, categories) {
    Object.assign(state, { categories })
  },

  [types.SET_CATEGORIES_TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoadingCategories: !state.isLoadingCategories })
  },

  [types.SET_TERRITORIES] (state, territories) {
    Object.assign(state, { territories })
  },

  [types.SET_TERRITORIES_TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoadingTerritories: !state.isLoadingTerritories })
  },

  [types.SET_GAMES] (state, games) {
    Object.assign(state, { games })
  },

  [types.SET_GAMES_TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoadingGames: !state.isLoadingGames })
  }
}
